import { defineMessages } from 'react-intl';

const messages = defineMessages({
  ActionName: 'Action name',
  Document: 'Document',
  Actions: 'Actions',
  Task: 'Task',
  Save: 'Save',
  Cancel: 'Cancel',
  Add: 'Add',
  DaysBefore: 'Start search period compared to reference date',
  DaysAfter: 'End search period compared to reference date',
  WorkflowType: 'Workflow type',
  WorkflowConfigurationListTitle: 'Workflow configurations',
  TaskStatus: 'Task status',
  NewTaskStatus: 'New status',
  ReferenceDate: 'Referencedate',
  LastDayOfVatPeriod: 'Last day of the VAT period',
  MarkAsBlocked: 'Mark as blocked',
  MarkAsInapplicable: 'Mark as inapplicable',
  RequireDocumentSigned: 'Require document to be signed to trigger taskflow',
  TaskflowAction: 'Taskflow action',
  Choose: 'Choose',
  ChangesSaved: 'Changes saved',
  Subtask: 'Subtask',
  StartTypingToSearch: 'Start typing to search',
  AllSubtasksWillBeSetToDoneIfYouDontSelectOne:
    'If you only select the main task, and the status is set to "done", all subtasks will also be moved to "done"',

  GeneratedDocumentQrCodeScannedInfo:
    'The task that will be updated is based on the task linked to the originally generated document.',
  DontChangeStatus: "Don't change the status",
  TaskTemplateNotFoundProbablyDeleted: 'Task template not found, it was probably removed!',
  TheDeadlineOfTheSubtasksWillBeAdjustedAsConfiguredInTaskTemplate:
    'If you only select the main task, the deadline of all subtasks will be adjusted as configured in the task template.',
  ActionWorkflowNameInfo:
    'This action name will be displayed on the confirmation page, in the language of the relation.',
  DocumentWorkflows: 'Document workflows',
  ActionWorkflows: 'Action workflows',
  Name: 'Name',
  PreviewConfirmText: 'Please click the button below to confirm.',
  PreviewConfirmButton: 'Confirm',
  Preview: 'Preview',
  Language: 'Language',
  Company: 'Company',
});

export default messages;
